import React, { useState } from 'react';

import { Box, Dialog, H3, Text } from '@betterment/samba-react';

import IntegrationCardContainer from './IntegrationCardContainer';
import IntegrationConnectionStatus from './IntegrationConnectionStatus';
import IntegrationImage from './IntegrationImage';

import { Notification } from '../../../apps/FirmIntegrationsApp';
import { OutboundIntegration, OutboundIntegrationType } from '../../../graphql/schema';
// https://github.com/vitejs/vite/issues/19778
import image from '../../../images/copilot.png?url';
import IntegrationDisconnectModal from '../IntegrationDisconnectModal';
import IntegrationMenu from '../IntegrationMenu';

const IntegrationConnectCard: React.FC<{
  integration: OutboundIntegration;
  setNotification: (notification: Notification) => void;
}> = ({ integration, setNotification }) => {
  const { name, description, isSubscribed, logoUrl, integrationType } = integration;
  const [isDisconnectModalOpen, setIsDisconnectModalOpen] = useState<boolean>(false);

  const is401k = integrationType === OutboundIntegrationType.Advised_401KCustodialFeed;

  return (
    <IntegrationCardContainer>
      <Box
        css={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <IntegrationImage src={logoUrl || image} />
        {isSubscribed && (
          <>
            <IntegrationMenu
              onDisconnect={() => {
                setIsDisconnectModalOpen(true);
              }}
            />
            <Dialog open={isDisconnectModalOpen} onOpenChange={setIsDisconnectModalOpen} overlay="default">
              <IntegrationDisconnectModal
                integration={integration}
                saveHandler={() => {
                  setNotification({
                    variant: 'info',
                    message: `Your firm is now disconnected from ${integration.name}.`,
                  });
                  setIsDisconnectModalOpen(false);
                }}
              />
            </Dialog>
          </>
        )}
      </Box>
      <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.100', pt: 'space.200', pb: 'space.50' }}>
        <H3 color="text" variant="title100">
          {name}
        </H3>
        <Text
          variant="text25"
          css={{
            color: 'text.accent.blue',
            py: 'space.50',
            px: 'space.100',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'primitives.blue.20',
            width: 'fit-content',
            borderRadius: 'round',
            visibility: is401k ? 'visible' : 'hidden',
          }}
        >
          401(k)
        </Text>
      </Box>
      <Text color="text.weak" variant="text50" css={{ flex: '1' }}>
        {description}
      </Text>
      <Box css={{ pt: 'space.300' }}>
        <IntegrationConnectionStatus integration={integration} setNotification={setNotification} />
      </Box>
    </IntegrationCardContainer>
  );
};

export default IntegrationConnectCard;
